import { makeAutoObservable } from "mobx";
import * as NotAvailableNowLabel from "./NotAvailableNowLabel";
import * as TemporarilyUnavailableLabel from "./TemporarilyUnavailableLabel";
const labelCreators = [
    TemporarilyUnavailableLabel.createLabel(),
    NotAvailableNowLabel.createLabel(),
];
export class LabelsCreator {
    constructor(params) {
        this.scope = params.scope;
        this.orderingHours = params.orderingHours;
        this.productInstances = params.productInstances;
        makeAutoObservable(this);
    }
    get labels() {
        return labelCreators
            .map((labelCreator) => labelCreator({
            now: this.scope.now,
            fulfillmentTime: this.scope.fulfillmentTime,
            productInstances: this.productInstances,
            orderingHours: this.orderingHours,
        }))
            .filter((label) => label !== null);
    }
}
